module.exports = __webpack_public_path__ + "media/answer_reverse.b623685d.mp3";